import React, { useEffect, useState } from 'react';
import { Button, Toast } from 'antd-mobile';
import TitleComponent from '../comm/title/title';
import styles from '../affirm/affirm.module.scss';
import { ApiCore } from '../../../api';
import IconUser from '../../../static/images/doctor.png';

const api = new ApiCore();

function AffirmComponent(props: any) {

    const [userData, setUserData] = useState<any>(null);

    useEffect(() => {
        //设置网页title
        document.title = '详情';

        if (props.location.params) {
            setUserData(props.location.params)
        } else {
            let userData = sessionStorage.getItem('affirmUserData')
            if (userData) {
                let data = JSON.parse(userData)
                setUserData(data)
            }
        }

    }, [])

    // 立即绑定
    const onBind = () => {
        props.history.push({ pathname: `/findList/diseases/diseases`});
    }
    
    // 取消绑定
    const cancleBind = () => {
        props.history.push(`/findList/phoneNumber/phoneNumber`)
    }

    return (
        <div className={'content_wrap'}>
            
            <div className={styles.affirmContent}>
                <TitleComponent title='请确认信息' subTitle={<>请确认以下账号是否属于您，<br/>确认后您当前的EDC账号将与该账号进行绑定</>} />
                
                <div className={styles.userInfoWrap}>
                    <img src={(userData && userData.avatar) || IconUser} alt='' width='30%'/>
                    <div className={styles.name}>{(userData && userData.nickName) || '--'}</div>
                </div>

                <div className={styles.buttonGroup}>
                    <Button
                        className={`${styles.btn}`}
                        type="primary"
                        onClick={() => onBind()}
                    >
                        是我的，立即绑定
                    </Button>
                    <Button
                        className={`${styles.btn} ${styles.cancle}`}
                        onClick={() => cancleBind()}
                    >
                        取消绑定
                    </Button>
                </div>
            </div>

        </div>
    )

}

export default AffirmComponent;